module.exports = __webpack_public_path__ + "9747f7c4800570fff6431e8c38a7d56a.svg";